import { useState } from "react";



const BiegungInput = (props) => {


const [isKraft, setKraft] = useState(100);
const [isLaenge, setLaenge] = useState(1000);

const Laenge = (event) =>{
    if(event.target.value > 6000) {setLaenge(6000)}else{ setLaenge(event.target.value)}
     if(event.target.value < 0){  setLaenge(0)}
}

const Kraft = (event) => {
if(event.target.value < 0){
    setKraft(0)
}else{
    setKraft(event.target.value)
}
}


props.onInputData(isKraft, isLaenge);

 return(<>
  <div className="col-4 posi-col-4-Input">
      <div className="Input-container">
        <div className="Kraft-container">
            <label htmlFor="newton">{props.language === "DE" ? "Kraft in Newton" : "Force in Newton"}</label>
            <input type="number" name="newton" id="kraftid" value={isKraft} 
            onChange={(event) => {Kraft(event)}}
            />
        </div>
        <div className="Kraft-container">
            <label htmlFor="Laenge">{props.language === "DE" ? "Länge in mm" : "Length in mm"}</label>
            <input type="number" name="Laenge" id="laenge_id" value={isLaenge} 
            onChange={(event) =>{Laenge(event)}
        }
            />
        </div>
      </div>
  </div>
 </>);
}

export default BiegungInput;